export const propertyUnitLabels = {
   density: {
      SI: '(g/cm³)',
      US: '(g/cm³)'
   },
   flowRate: {
      SI: '(g/10 min)',
      US: '(g/10 min)'
   },
   notchedImpactIso: {
      SI: '(kJ/m²)',
      US: '(ft-lb/in²)'
   },
   notchedImpactAstm: {
      SI: '(J/m)',
      US: '(ft-lb/in)'
   }
};

/**
 * Used by the filter mapper, product detail table and product compare table
 * so that standard names and unit strings stay consistent everywhere.
 */
export const notchedImpactConfig: Record<'ISO' | 'ASTM', Record<'SI' | 'US', { standard: string; unit: string }>> = {
   ISO: {
      SI: { standard: 'ISO 180', unit: 'kJ/m²' },
      US: { standard: 'ISO 180', unit: 'ft-lb/in²' }
   },
   ASTM: {
      SI: { standard: 'ASTM 256', unit: 'J/m' },
      US: { standard: 'ASTM 256', unit: 'ft-lb/in' }
   }
};
